import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import PropTypes from 'prop-types';
import useCldrDataReducer from '../useCldrDataReducer';
import gregorianLocale from './cldr/ca-gregorian.json';
import currenciesLocale from './cldr/currencies.json';
import dateFieldsLocale from './cldr/dateFields.json';
import numbersLocale from './cldr/numbers.json';
import territoriesLocale from './cldr/territories.json';
import timeZoneNamesLocale from './cldr/timeZoneNames.json';
import unitsLocale from './cldr/units.json';

function CldrLocaleSr(_ref) {
  var children = _ref.children,
      cldrData = _ref.cldrData,
      disableCurrency = _ref.disableCurrency,
      disableDate = _ref.disableDate,
      disableNumber = _ref.disableNumber,
      disablePlural = _ref.disablePlural,
      disableRelativeTime = _ref.disableRelativeTime,
      disableTerritories = _ref.disableTerritories,
      disableUnits = _ref.disableUnits;
  var result = useCldrDataReducer(useCldrDataReducer.TYPE_LOCALE, {
    numbersLocale: numbersLocale,
    dateFieldsLocale: dateFieldsLocale,
    unitsLocale: unitsLocale,
    currenciesLocale: currenciesLocale,
    gregorianLocale: gregorianLocale,
    territoriesLocale: territoriesLocale,
    timeZoneNamesLocale: timeZoneNamesLocale
  }, {
    disableCurrency: disableCurrency,
    disableDate: disableDate,
    disableNumber: disableNumber,
    disablePlural: disablePlural,
    disableRelativeTime: disableRelativeTime,
    disableTerritories: disableTerritories,
    disableUnits: disableUnits
  });
  return children([].concat(_toConsumableArray(cldrData), _toConsumableArray(result)));
}

CldrLocaleSr.propTypes = {
  children: PropTypes.func.isRequired,
  cldrData: PropTypes.arrayOf(PropTypes.object),
  disableCurrency: PropTypes.bool,
  disableDate: PropTypes.bool,
  disableNumber: PropTypes.bool,
  disablePlural: PropTypes.bool,
  disableRelativeTime: PropTypes.bool,
  disableTerritories: PropTypes.bool,
  disableUnits: PropTypes.bool
};
CldrLocaleSr.defaultProps = {
  disableCurrency: false,
  disableDate: false,
  disableNumber: false,
  disablePlural: false,
  disableRelativeTime: true,
  disableTerritories: false,
  disableUnits: false
};
export default CldrLocaleSr;